// A2 — Admin-only tour: Roles & Permissions Overview. 3 steps on /roles.
export default {
  key: 'A2',
    route: '/roles',
  steps: [
    {
      id: 'roles',
      target: '[data-tour-id="roles.list"]',
      title: 'Roles',
      desc: 'Roles define what each user can see and do. Each user is assigned one role.',
    },
    {
      id: 'permissions',
      target: '[data-tour-id="roles.permissions-section"]',
      title: 'Permissions',
      desc: 'A role grants View or Edit permission per area (Inquiries, Orders, Workcenters, Reports, ...). Plus per-Site and per-Workcenter access.',
    },
    {
      id: 'special-roles',
      target: '[data-tour-id="roles.permissions-section"]',
      title: 'Special roles',
      desc: 'Two special checkboxes: Admin grants everything. ShopFloorWorker auto-routes users to the Shopfloor screen on login — workers use barcodes there, no menus.',
    },
  ],
}
